import ReactMarkdown from "react-markdown";
import specMd from 'bundle-text:./spec.md';

export function SpecificationSection() {

    return <ReactMarkdown className="spec-markdown">{specMd}</ReactMarkdown>;
}
